<template>
    <div>
        <div v-if="isLoading" class="intelligence-state">
            <common-loader :isProcessing="true"></common-loader>
            <span>{{ $t('pages.intelligence.constraints.loading') }}</span>
        </div>

        <div v-else-if="hasError" class="intelligence-state intelligence-state--error">
            {{ $t('pages.intelligence.constraints.error') }}
        </div>

        <template v-else-if="constraints">
            <intelligence-constraint-chart :breakdown="constraints.reasons"></intelligence-constraint-chart>
            <intelligence-constraints-table :reasons="constraints.reasons"></intelligence-constraints-table>
        </template>
    </div>
</template>

<script>
    import PageWithTitleMixin from 'mixins/PageWithTitleMixin'
    import IntelligenceConstraintChart from 'components/page-elements/intelligence/IntelligenceConstraintChart'
    import IntelligenceConstraintsTable from 'components/page-elements/intelligence/IntelligenceConstraintsTable'
    import IntelligenceAPI from 'api/IntelligenceAPI'

    export default {
        mixins: [PageWithTitleMixin],

        components: {
            IntelligenceConstraintChart,
            IntelligenceConstraintsTable,
        },

        props: {
            filters: { type: Object, default: null },
        },

        data() {
            return {
                isLoading: false,
                hasError: false,
                constraints: null,
            }
        },

        computed: {
            pageTitle() {
                return this.$t('pages.intelligence.constraints.title')
            },
        },

        methods: {
            loadConstraints() {
                if (!this.filters || !this.filters.fromDate || !this.filters.toDate) return

                this.isLoading = true
                this.hasError = false

                IntelligenceAPI.getConstraints(this.filters)
                    .then((response) => {
                        this.constraints = response
                    })
                    .catch(() => {
                        this.hasError = true
                        this.constraints = null
                    })
                    .finally(() => {
                        this.isLoading = false
                    })
            },
        },

        watch: {
            filters: {
                immediate: true,
                handler() {
                    this.loadConstraints()
                },
            },
        },
    }
</script>

<style lang="scss" scoped>
    .intelligence-state {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 32px;
        color: #6b7280;
        font-size: 14px;

        &--error {
            color: #b91c1c;
        }
    }
</style>
